import request from '@/router/axios'

export function fetchGoodsList (query) {
    return request({
      url: '/mall/admin/goods/page',
      method: 'get',
      params: query
    })
}

export function updateSkuValue(params) {
    return request({
      url: '/mall/admin/goods/sku',
      method: 'put',
      data: params,
    });
}

export function updateGoodsTopStatus(params) {
    return request({
      url: '/mall/admin/goods/top/',
      method: 'put',
      data: params,
    });
}

export function updateGoodsBanStatus(params) {
    return request({
      url: '/mall/admin/goods/banStatus/',
      method: 'put',
      data: params,
    });
}

export function getGoods (id) {
    return request({
      url: '/mall/admin/goods/' + id,
      method: 'get'
    })
}

export function saveGoods(data) {
  return request({
    url: '/mall/admin/goods/',
    method: 'post',
    data
  })
}

export function updateGoodsById(data) {
  return request({
    url: '/mall/admin/goods/',
    method: 'put',
    data
  })
}

export function syncGoodsCache() {
  return request({
    url: '/mall/admin/goods/sync-cache',
    method: 'put',
  })
}
